<!-- Render the card template -->
<ng-container *ngTemplateOutlet="cardTemplate" />

<!-- ===========================
Main Card Template
=========================== -->
<ng-template #cardTemplate>
  <!-- header -->
  @if (HeaderTemplate) {
    <ng-container
      *ngTemplateOutlet="
        HeaderTemplate.tempRef;
        context: HeaderTemplate?.tempContext
      "
    />
  }

  <!-- Dynamic Layout: Image ↔ Body -->
  <ng-container *ngTemplateOutlet="topSection" />
  <ng-container *ngTemplateOutlet="bottomSection" />

  <!-- footer -->
  @if (FooterTemplate) {
    <div class="card-footer">
      <ng-container
        *ngTemplateOutlet="
          FooterTemplate.tempRef;
          context: FooterTemplate?.tempContext
        "
      />
    </div>
  }
</ng-template>

<!-- ===========================
Card Body Block
=========================== -->
<ng-template #cardBody>
  <!-- body as template ref -->
  @if (BodyTemplate) {
    <ng-container
      *ngTemplateOutlet="
        BodyTemplate.tempRef;
        context: BodyTemplate?.tempContext
      "
    />
  } @else {
    <div class="card-body" [class]="BodyClassStyle">
      <!-- single title -->
      @if (title) {
        <h5 class="card-title">{{ title }}</h5>
      }
      <!-- content body -->
      <ng-content select="*" />
    </div>
  }
</ng-template>

<!-- ===========================
Card Image Block
=========================== -->
<ng-template #imageBlock>
  @if (ImageTemplate || Image) {
    <ng-container
      *ngTemplateOutlet="
        ImageTemplate?.tempRef ?? defaultCardImage;
        context: ImageTemplate?.tempContext ?? Image
      "
    />
  }
</ng-template>

<!-- ===========================
  Default Image Template
  =========================== -->
<ng-template
  #defaultCardImage
  let-src="src"
  let-alt="alt"
  let-position="position"
  let-classStyle="classStyle"
>
  <img
    [src]="src"
    [alt]="alt"
    [ngClass]="classStyle"
    class="card-img-{{ position ?? 'top' }}"
  />
</ng-template>
